module.exports = __webpack_public_path__ + "static/og-booked-42c1a7fc80e19809004250483b155211.png";